import * as React from 'react';
import { compose, setDisplayName } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { ReportType } from 'types';
import { getTextKeyForColumn } from 'logic/reports/getTextKeyForColumn';

export type OwnProps = {
    reportType: ReportType;
    name: string;
    checked: boolean;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
};

const RawGraphDefaultOption = ({ reportType, name, checked, onChange, t }: OwnProps & TranslateProps) =>
    <div>
        <input
            id={ `edit-report-graph-default-${name}` }
            type="radio"
            checked={ checked }
            value={ name }
            onChange={ onChange }
        />
        <label
            htmlFor={ `edit-report-graph-default-${name}` }
        >
            { t(getTextKeyForColumn(reportType, name)) }
        </label>
    </div>
;

export const GraphDefaultOption = compose<OwnProps & TranslateProps, OwnProps>(
    setDisplayName('GraphDefaultOption'),
    translate(),
)(RawGraphDefaultOption);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/graph/GraphDefaultOption.tsx